import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import { useTheme } from '../hooks/index';

const DateProvider = ({ children, primary }) => {
  const theme = useTheme();

  const defaultMaterialTheme = useMemo(() => {
    return {
      components: {
        typography: {
          fontFamily: ['Poppins', 'Open Sans']
        },
        palette: {
          primary: { main: primary || theme.gradient.from }
        },
        overrides: {
          MuiButton: {
            textPrimary: {
              color: '#000000'
            }
          }
        }
      }
    };
  }, [theme, primary]);

  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {children}
      </LocalizationProvider>
    </ThemeProvider>
  );
};

DateProvider.propTypes = {
  primary: PropTypes.string
};

export default DateProvider;
